exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.privaatsuspoliitika[data-v-ca2922b6]{width:60%;margin:0 auto;text-align:left\n}\n.privaatsuspoliitika strong[data-v-ca2922b6]{font-weight:600\n}\n.privaatsuspoliitika ol[data-v-ca2922b6]{margin-bottom:20px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca2922b6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Privaatsuspoliitika.vue
// module id = 215
// module chunks = 0